import * as yup from "yup";
const phoneRegExp = /^([0][7,9][0-9]{8})$/;
const shortNameReg = /^([a-z,A-Z]{3})$/;
const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png"];

export const patient = yup.object().shape({
  firstName: yup.string().required("First Name is Required!"),
  middleName: yup.string().required("Middle Name is Required!"),
  lastName: yup.string().required("Last Name is Required!"),
  phoneNo: yup
    .string()
    .required("Phone Number is Required!")
    .matches(phoneRegExp, {
      message: "Phone Number is not valid",
      excludeEmptyString: true,
    }),
  branchId: yup.string().required("Branch is Required!"),
  gender: yup.string().required("Gender is Required!"),
  dob: yup
    .date()
    .typeError("Date of Birth is Required!")
    .required("Date of Birth is Required!"),
});

export const branch = yup.object().shape({
  name: yup.string().required("Name is Required!"),
  shortName: yup
    .string()
    .required("Short Name is Required!")
    .matches(shortNameReg, {
      message: "Short Name Must be Alphabets and 3 Character only",
      excludeEmptyString: true,
    }),
});

export const patientAddress = yup.object().shape({
  addresses: yup
    .array()
    .min(1, "Atleast add one address!")
    .required("Atleast add one address!"),
});

export const staff = yup.object().shape({
  firstName: yup.string().required("First Name is Required!"),
  middleName: yup.string().required("Middle Name is Required!"),
  lastName: yup.string().required("Last Name is Required!"),
  phoneNo: yup
    .string()
    .required("Phone Number is Required!")
    .matches(phoneRegExp, {
      message: "Phone Number is not valid",
      excludeEmptyString: true,
    }),
  branchId: yup.string().required("Branch is Required!"),
  gender: yup.string().required("Gender is Required!"),
  dob: yup
    .date()
    .typeError("Date of Birth is Required!")
    .required("Date of Birth is Required!"),
});

export const staffAddress = yup.object().shape({
  addresses: yup
    .array()
    .min(1, "Atleast add one address!")
    .required("Atleast add one address!"),
});

export const takenTreatment = yup.object().shape({
  treatmentId: yup.string().required("Treatment is Required!"),
  price: yup
    .number()
    .required("Price is Required!")
    .typeError("Price is Required!")
    .min(1, "Price minimum can't be less than 1"),
  appointment: yup.object().shape({
    start: yup.string().required("Start Date is Required!"),
    end: yup.string().required("End Date is Required!"),
    cycle: yup
      .number()
      .min(1, "Cycle must be 1!")
      .required("Cycle is Required!")
      .typeError("Cycle is Required!"),
  }),
});

export const transaction = yup.object().shape({
  amount: yup.number().min(0.01, "Amount can't be < 0.01").required("Amount is Required!").typeError("Amount is Required!"),
  description: yup.string().required("Description is Required!"),
  purpose: yup.string().required("Purpose is Required!"),
});

export const treatment = yup.object().shape({
  name: yup.string().required("Name is Required!"),
  minPrice: yup
    .number()
    .min(1, "Min Price must be 1!")
    .required("Min Price is Required!")
    .typeError("Min Price is Required!"),
  maxPrice: yup
    .number()
    .min(yup.ref("minPrice"), "Max Price can't be less than Min Price!")
    .required("Max Price is Required!")
    .typeError("Max Price is Required!"),
});

export const treatmentRange = yup.object().shape({
  ranges: yup.array().of(
    yup.object().shape({
      name: yup.string().required("Name is Required!"),
      min: yup
        .number()
        .min(1, "Min must be 1!")
        .max(100, "Min maximum value must be 100!")
        .required("Min is Required!")
        .typeError("Min is Required!"),
      default: yup
        .number()
        .min(yup.ref("min"), "Default must be > Min!")
        .max(100, "Default must be 100!")
        .required("Default is Required!")
        .typeError("Default is Required!"),
      max: yup
        .number()
        .min(yup.ref("default"), "Max must be > Default!")
        .max(100, "Max must be 100!")
        .required("Max is Required!")
        .typeError("Max is Required!"),
    })
  ),
});

export const user = yup.object().shape({
  staffId: yup.string().required("Staff is Required!"),
  roleId: yup.string().required("Role is Required!"),
  email: yup.string().required("Email is Required!"),
  phoneNumber: yup
    .string()
    .required("Phone Number is Required!")
    .matches(phoneRegExp, {
      message: "Phone Number is not valid",
      excludeEmptyString: true,
    }),
  password: yup
    .string()
    .required("Password is Required!")
    .matches(
      /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
      "Must include Uppercase, Lowercase, Special Charachter & Number"
    ),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password")], "Password and Confirm Password must match!"),
});

export const userSaas = yup.object().shape({
  email: yup.string().required("Email is Required!"),
  name: yup.string().required("Your Dental Clinic Name is Required!"),
  firstName: yup.string().required("First Name is Required!"),
  pic_url: yup.mixed().when("img", {
        is: (img: any) => img?.length > 0,
        then: yup
          .mixed()
          .test(
            "fileType",
            "Unsuported File Format, Please use jpg or png image formats",
            (value: any) => SUPPORTED_FORMATS.includes(value?.[0]?.type)
          )
          .test(
            "fileSize",
            "File Size is too large, use less than or equal to 2Mb",
            (value: any) => value?.[0]?.size <= 2097152
          ),
      }),
  phoneNumber: yup
    .string()
    .required("Phone Number is Required!")
    .matches(phoneRegExp, {
      message: "Phone Number is not valid",
      excludeEmptyString: true,
    }),
  password: yup
    .string()
    .required("Password is Required!")
    .matches(
      /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
      "Must include Uppercase, Lowercase, Special Charachter & Number"
    ),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password")], "Password and Confirm Password must match!"),
});

export const changePassword = yup.object().shape({
  id: yup.number().required("Id is Required!").typeError("Id is Required!"),
  oldPassword: yup.string().required("Old Password is Required!"),
  password: yup
    .string()
    .required("New Password is Required!")
    .matches(
      /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
      "Must include Uppercase, Lowercase, Special Charachter & Number"
    ),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password")], "New Password and Confirm New Password must match!"),
});
